export enum IInboxRouteEnum {
  INBOX = "inbox",
  CHAT = "inbox.chat",
  SETTINGS = "inbox.settings",
}
